<template lang="pug">
.benchmarks-timers
  .timers-section
    p
      | These timers
      |
      strong do
      |
      | track activity
      |

    .timers-section-wrapper
      .timers-platform
        p.timers-platform-title
          |
          strong Desktop apps
          |
          span.text-muted (also record screenshots)
        .timers-platform-wrapper
          a.timers-item(
            v-for="sys in platforms.desktop"
            :key="sys.name"
            :href="download_url"
            rel="noopener noreferrer"
            target="_blank"
          )
            img.timers-item-img(
              :alt="sys.name"
              :src="sys.image"
            )
            p {{ sys.name }}
      .timers-platform
        p.timers-platform-title
          strong Browser apps
        .timers-platform-wrapper
          a.timers-item(
            v-for="sys in platforms.browser"
            :key="sys.name"
            :href="download_url"
            rel="noopener noreferrer"
            target="_blank"
          )
            img.timers-item-img(
              :alt="sys.name"
              :src="sys.image"
            )
            p {{ sys.name }}
  .timers-section
    p
      | These timers
      |
      strong do not
      |
      | track activity
      |
    .timers-section-wrapper
      .timers-platform
        p.timers-platform-title
          strong Mobile apps
        .timers-platform-wrapper
          a.timers-item(
            v-for="sys in platforms.mobile"
            :key="sys.name"
            :href="download_url"
            rel="noopener noreferrer"
            target="_blank"
          )
            img.timers-item-img(
              :alt="sys.name"
              :src="sys.image"
            )
            p {{ sys.name }}
      .timers-platform
        p.timers-platform-title
          strong Web timer
        .timers-platform-wrapper
          .timers-item(
            v-for="sys in platforms.web"
            :key="sys.name"
          )
            img.timers-item-img.lg(
              v-tooltip="true"
              :alt="sys.name"
              :src="sys.image"
              data-placement="top"
              :title="webTimerTooltip"
            )
            p {{ sys.name }}
</template>

<script>
import { HS_TIMER_PLATFORMS } from '~/app_constants';
import { mapState } from 'vuex';

export default {
  name: 'ActivitiesBenchmarksDialogTimers',
  data: () => ({
    platforms: Object.freeze(HS_TIMER_PLATFORMS),
    webTimerTooltip:
      'The web timer is accessible from the top navigation bar. The web timer is not supported on mobile.',
  }),
  computed: {
    ...mapState([
      'download_url',
    ]),
  }
};
</script>
